import { Injectable, Injector, inject } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class RootInjector {
    static injector: Injector;

    constructor() {
        const injector = inject(Injector);

        RootInjector.injector = injector;
    }
}
